module.exports = __webpack_public_path__ + "static/media/hat-covered.ee6a6dca.svg";